// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__19cfn","list":"PatternAutocomplete_list__1Oj4D"};